export class AiImage {
    image: string;
    selected: boolean;
    url?: string;

    constructor(query: { image: string }) {
        if (query) {
            this.image = query.image;
        }
        this.selected = false;
    }
}
